import { ELogoutActionTypes, TLogoutSucceed } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const logoutSuccess: () => TLogoutSucceed = actionGenerator<ELogoutActionTypes.Succeed>(
  ELogoutActionTypes.Succeed,
);
